var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayingMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.65 13.43c-1.09-.11-1 0-.95-.11a5.06 5.06 0 0 0 1.17-3.15 14.72 14.72 0 0 0-.31-1.76c-.13-.13-.27-.08-.4 0s-.18 1.53-.33 2.53A7.31 7.31 0 0 1 18 13a.34.34 0 0 0-.15.29 48.32 48.32 0 0 0-5 0c-5.94.25-11.4 0-12.23 2.4a8.48 8.48 0 0 0-.19 3C.61 21.18.55 22 3.7 22.07c-.7.74-.31 1.73 0 1.78.51.08.74-1 .66-1.74a84.55 84.55 0 0 0 9.71.14c1.61 0 3.16.12 4.78 0-.27 1.51 1.35 3.06 1-.1a3.85 3.85 0 0 0 2.53-1 5.66 5.66 0 0 0 .94-4.28c-.19-2.07-.52-3.11-3.67-3.44Zm2.45 5.81a2.87 2.87 0 0 1-.59 1.2c-.88 1-5.52.68-7.46.7-1.71 0-3.41.14-5.12.17-.68 0-6.32 0-7.1-.37s-.56-1.56-.61-2.26a7.67 7.67 0 0 1 .08-2.78c.39-1.23.53-1.51 11.61-1.75 1.31 0 6.57 0 8.27.66a1.32 1.32 0 0 1 .83.76 9.79 9.79 0 0 1 .09 3.67Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.64 16.41c-.27-.05-4.67-.21-7-.12-3 .11-3.49.24-3.69 1.4a3.51 3.51 0 0 0-.11 1.36c.26 1 1.79.7 3.36.71 2 0 2.93.13 5.25.08s2.66 0 2.94-.52.33-2.72-.75-2.91Zm-.24 2.2c-.26.06 0 0-7.22.27-3.37.14-2.69.37-2.61-1.1 0-.7.37-.55 1.2-.59a20.85 20.85 0 0 1 3.76-.05c1.76.09 4.13.28 4.49.31s.58.01.38 1.16Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78 19.07c1 .54 2.4.34 2.58-1.06.5-4.35-6.44-1.01-2.58 1.06Zm1.71-1.22c-.14.59-.74.47-1.18.23s-.73-.64-.31-1.08c.08 0 1.27-1.07 1.49.41Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64 12.87a.3.3 0 0 0 .47-.36c-1-1.38-1.3-4.87.29-7.52a8.71 8.71 0 0 1 7.14-4c4.78-.15 5.68 3 6.34 2.28a.33.33 0 0 0 0-.47c-.47-.39-.88-.8-1.32-1.14C11.77-1.36 5-.17 2.47 4.45c-1.58 2.88-1.1 6.85.17 8.42Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.44 2.08c-.11-.76-.28-1.46-1-1.73a3.34 3.34 0 0 0-2 .14c-1 .26-2.31.5-2.63 1.56a8.5 8.5 0 0 0-.15 2.88 2 2 0 0 0-2.16 1.18c-.77 2 2.56 3.28 3.12.17.19-1.12-.07-2.83.27-3.9.07-.25.35-.36.63-.46a17.47 17.47 0 0 1 2.11-.55c.48-.06.53.07.6.24a11 11 0 0 1 .36 2.13 1.62 1.62 0 0 0-1.81 1.1 1.24 1.24 0 0 0 1.36 1.61c1.65-.37 1.54-2.72 1.3-4.37ZM17 7.25a.66.66 0 0 1-.76-.88 1.31 1.31 0 0 1 1.46-.81c-.01.62-.09 1.57-.7 1.69Zm4.67-1.73c-.35-.51 0-1.08.77-1.09l.17 0c-.1 1.25-.75 1.36-.94 1.09Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83 11.75a3.75 3.75 0 0 0 4.38-1 3.22 3.22 0 0 0-.48-4.44C8.26 3.35 5 9.88 8.83 11.75Zm3.58-1.65a2.85 2.85 0 0 1-3.1.63c-1.63-.73-1.41-3.31.2-4.21a3.14 3.14 0 0 1 2.77.42 2.33 2.33 0 0 1 .13 3.16Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayingMusic);
export default __webpack_public_path__ + "static/media/playing-music.ea21a122ad78e26a03c50a340236eeb1.svg";
export { ForwardRef as ReactComponent };